import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum SelectedShippingRateSetBy {
  USER = "user",
  LEARNING = "learning",
  AUTOMATIONS = "automations",
  DEFAULT_CHEAPEST = "default_cheapest",
  CHECKOUT_RATE_PURCHASED = "checkout_rate_purchased",
}

export const SelectedShippingRateSetByInfoSchema = z.object({
  selectedShippingRateUserId: zExt.objectId().nullish(),
  selectedShippingRateAutomationId: zExt.objectId().nullish(),
  selectedShippingRateAutomationName: z.string().nullish(),
});

export type SelectedShippingRateSetByInfo = z.infer<
  typeof SelectedShippingRateSetByInfoSchema
>;
